import React from "react";
import { Box, Stack, Skeleton, Divider } from "@mui/material";

export const InvitationDetailSkeleton: React.FC = () => {
  return (
    <Box>
      <Skeleton width="30%" height={20} />
      <Stack direction="row" spacing={2} alignItems="center" mb={2}>
        <Skeleton width={40} height={40} variant="circular" />
        <Box width="100%">
          <Skeleton width="40%" height={20} />
          <Stack spacing={1} direction="column">
            <Stack direction="row" spacing={1} alignItems="center">
              <Skeleton width={20} height={20} variant="circular" />
              <Skeleton width="40%" height={20} />
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <Skeleton width={20} height={20} variant="circular" />
              <Skeleton width="60%" height={20} />
            </Stack>
          </Stack>
        </Box>
      </Stack>
      <Divider sx={{ my: 2 }} />
      <Skeleton width="50%" height={20} />
      <Stack spacing={1} width="100%">
        <Stack width="100%" direction="row" spacing={1} alignItems="center">
          <Skeleton width={20} height={20} variant="circular" />
          <Skeleton width="60%" height={20} />
        </Stack>
        <Stack width="100%" direction="row" spacing={1} alignItems="flex-start">
          <Skeleton width={20} height={20} variant="circular" />
          <Box width="100%">
            <Skeleton width="50%" height={20} />
            <Skeleton width="40%" height={20} />
            <Skeleton width="60%" height={20} />
            <Skeleton width="30%" height={20} />
          </Box>
        </Stack>
      </Stack>

      <Stack marginTop={2} direction="column" spacing={2}>
        <Skeleton width="100%" height={40} variant="rounded" sx={{ borderRadius: 6 }} />
        <Skeleton width="100%" height={40} variant="rounded" sx={{ borderRadius: 6 }} />
      </Stack>
    </Box>
  );
};
